/**
 * Format a byte count as a human-readable size, choosing the unit so small
 * files don't collapse to "0.0 MB": under 1 KB shows as B, under 1 MB as KB,
 * otherwise MB. Shared so the model-facing note and the UI render the same
 * string for the same bytes.
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  // Guard the rounded value too, so 1023.5–1023.99 KB shows as 1 MB, not "1024 KB".
  if (Math.round(kb) < 1024) return `${Math.round(kb)} KB`;
  const mb = bytes / (1024 * 1024);
  return `${Number.isInteger(mb) ? mb : mb.toFixed(1)} MB`;
};
